"use client";

import { useMemo, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import ExperienceCard from "./experienceCard";
import Button from "../ui/button";
import { Experience } from "../../../global";

export default function ExperienceItems({
    experiences,
    selectedTag,
}: {
    experiences: Experience[];
    selectedTag: string;
}) {
    const [count, setCount] = useState(9);

    const filtered = useMemo(() => {
        return selectedTag === "All"
            ? experiences
            : experiences.filter((exp) =>
                  exp.tags?.map((t) => t.trim()).includes(selectedTag)
              );
    }, [experiences, selectedTag]);

    const visible = useMemo(() => filtered.slice(0, count), [filtered, count]);

    return (
        <>
            <TransitionGroup
                component="div"
                className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-8 lg:gap-x-8"
            >
                {visible.map((exp) => (
                    <CSSTransition key={exp.id} timeout={500} classNames="fade">
                        <ExperienceCard {...exp} />
                    </CSSTransition>
                ))}
            </TransitionGroup>

            {count < filtered.length && (
                <div className="w-full flex justify-center mt-12">
                    <Button
                        className=""
                        text="Load More"
                        onClick={() => setCount(count + 3)}
                    />
                </div>
            )}
        </>
    );
}
